import React, { useState, useEffect } from "react";
import styled from "styled-components";

export const InputField = styled.input`
  font-family: inherit;
  min-height: 2.5em;
  width: 100%;
  box-sizing: border-box;
  font-size: 1em;
  border: none;
  padding: 1.2em 1.2em 0.8em;
  background: none;
  color: white;
  &:focus {
    outline: none;
  }
`;

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  className: string;
}
export default function Input(props: Props) {
  const [value, setValue] = useState(props.value || "");

  useEffect(() => {
    if (value !== props.value) setValue(props.value);
  }, [props.value, value]);

  const onChange = e => {
    const newValue = e.target.value;
    setValue(newValue);
    if (props.onChange) props.onChange(newValue);
  };

  return (
    <>
      <InputField
        type="text"
        onChange={onChange}
        value={value}
        className={props.className}
      />
    </>
  );
}
